import './story-backlinks.scss';

import StoryBacklinks from './StoryBacklinks';

export default StoryBacklinks;
